/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemFolderWrapper_item$ref = any;
type ItemHeartWrapper_item$ref = any;
type Tile_item$ref = any;
export type StorefrontProductTile_product$ref = any;
export type StorefrontProductTile_product = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly photos: ReadonlyArray<{
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly ecommerceTrackingParams: unknown | null;
    readonly " $fragmentRefs": ItemFolderWrapper_item$ref & ItemHeartWrapper_item$ref & Tile_item$ref;
    readonly " $refType": StorefrontProductTile_product$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "Variable",
            "name": "loadPortfolioData",
            "variableName": "hasUserId"
        } as any),
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "StorefrontProductTile_product",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "isTrade",
                "type": null
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "photos",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPhoto",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "versions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhotoVersion",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "webPath",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "ecommerceTrackingParams",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ItemFolderWrapper_item",
                "args": (v0 /*: any*/)
            },
            {
                "kind": "FragmentSpread",
                "name": "ItemHeartWrapper_item",
                "args": (v0 /*: any*/)
            },
            {
                "kind": "FragmentSpread",
                "name": "Tile_item",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTrade",
                        "variableName": "isTrade"
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '304ec7020099d89543fe3eb1af9fbb1a';
export default node;
